import type { JSX } from "react";

/**
 * Steps types for an auto generated multi-step form.
 */
export enum FormStepType {
    FieldSet,
    OtherJSX,
}

/**
 * A single step in a multi-step form that renders a set of form fields.
 */
export type FormStepFieldSet<FieldNames extends string> = Readonly<{
    stepType: FormStepType.FieldSet;
    groupTitle: string;
    fields: ReadonlyArray<FieldNames>;
}>;

/**
 * A single step in a multi-step form that renders some arbitrary JSX.
 */
export type FormStepOtherJSX = Readonly<{
    stepType: FormStepType.OtherJSX;
    buildContent: (index: number) => JSX.Element;
    summary?: JSX.Element;
}>;

/**
 * Union type for representing any form step
 */
export type FormStep<FieldNames extends string> =
    | FormStepFieldSet<FieldNames>
    | FormStepOtherJSX;
